<template>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose" :append-to-body="true">
    <el-form size="small" :model="form" ref="form" label-width="100px" class="demo-ruleForm">


      <!--<el-form-item
              label="所属目录"
              prop="categoryId"

      >
       <wlTreeSelect leaf width="240" :leaf="true":checkbox="false" :data="categoryModel.catList" @change="hindleChanged" v-model="selected"
      >

      </wlTreeSelect>      </el-form-item>-->


      <el-form-item
        label="专栏名称"
        prop="groupName"
        :rules="[
          { required: true, message: '名字不能为空'}
        ]"
      >
        <el-input  type="age" v-model="form.groupName" autocomplete="off"></el-input>
      </el-form-item>

<!--      <el-form-item label="专栏封面" prop="imageId" >-->
<!--        <el-row>-->
<!--          <el-button type="primary" @click="openUpload">选择图片</el-button>-->
<!--          <div v-if="form.imageId!=''" class="img">-->
<!--            <img :src="filePath" width="100" height="100" />-->
<!--          </div>-->
<!--        </el-row>-->
<!--      </el-form-item>-->


      <el-form-item>
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm()">提交</el-button>
      </el-form-item>
    </el-form>
    <Upload v-if="isupload" :isupload="isupload" :type="poster" @returnImgs="returnImgsFunc">上传图片</Upload>

  </el-dialog>
</template>

<script>
import FileApi from '@/api/file.js';
import PorductApi from '@/api/product.js';
import Upload from '@/components/file/Upload';


export default {
  components: {
    Upload
  },
  data(){
    return {
      checkSelect:null,
      value: [], // 选中值
      selectValue:[],
      selected: [  ],// 树下拉框选中数据
      categoryModel: {
        categoryType: -1, // 与第一个选项的 :value 匹配

        catList: [],
        model: {}
      },
      /*是否显示*/
      dialogVisible:true,
      title: '添加专栏',
      /*from表单模型*/
      formLabelWidth: '120px',
      isupload: false,

      form:{
        groupName:'',
        groupId: 0,
        categoryId:-1,// 关联类型id
        categoryType:1,// 关联类型
        imageId: ''

      }
    }
  },
  props:['category', 'fileType'],
  created() {
    if(this.category != null){
      this.form.groupName = this.category.groupName;
      this.form.groupId = this.category.groupId;
      this.form.categoryId=this.category.categoryId;
      this.form.categoryName=this.category.categoryName;

      this.title = '编辑专栏';
    }else{
      this.form.groupName = '';
      this.form.groupId = 0;
      this.title = '添加专栏';
    }
    this.getCategoryData();
    if(this.form.categoryId!=null&&this.form.categoryId!=0) {

      this.selected = [{name: this.form.categoryName, categoryId: this.form.categoryId}];
    }
  },
  methods:{
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.filePath = e[0].filePath;
        alert(this.filePath);
        this.form.imageId = e[0].fileId;
      }
      this.isupload = false;
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        })
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    hindleChanged(val){
      if(val.length==0){
        console.log("this.checkSelect",val)
        this.checkSelect=null;
      }else{
        console.log("this.checkSelect1",val)

        this.checkSelect="1";

      }
      // this.selectValue=[{name:val[0].parentName,categoryId:val[0].categoryId}];
      console.log(this.selected)
    },
    /*添加图片类别*/
    addCategory: function() {
      let self = this;
      console.log(self.selected);
      // if(self.selected.length==0){
      //   alert("请选择所属目录");
      //   return;
      // }
      // self.form.categoryId = self.selected[0].categoryId;

      FileApi.addCategory({
        categoryId:self.form.categoryId,
        categoryType:self.form.categoryType,
        groupName: self.form.groupName,
        groupType: self.fileType
      },).then(data => {
          self.$message({
            message: '添加成功',
            type: 'success'
          });
          self.handleClose({status:'success'});
        })
        .catch(error => {
          self.$message.error('添加失败');
        });
    },

    /*修改图片类别*/
    editCategory: function() {
      let self = this;

      let param = {
        categoryId:self.form.categoryId,
        groupName: this.form.groupName,
        groupId: this.form.groupId,
        categoryType:self.form.categoryType

      };
      FileApi.editCategory(param).then(data => {
          self.$message({
            message: '修改成功',
            type: 'success'
          });
          self.handleClose({status:'success'});
        })
        .catch(error => {
          self.$message.error('修改失败');
        });
    },
    /*获取分类列表*/
    getCategoryData() {

      let self = this;
      self.loading = true;

      PorductApi.catList({type: 1
      }, true)
              .then(res => {
                // let type = [{
                //   categoryId: 1,
                //   name: '全部'
                // }];
                self.loading = false;
                self.tableData = res.data;
                self.categoryModel.catList = self.tableData;
                console.log("##############",res.data)
                console.log("eeeee##############",self.categoryModel.catList)

              })
              .catch(error => {
                self.loading = false;
              });

    },
    /*提交*/
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.category && this.category.groupId != null){
            this.editCategory();
          }else{
            this.addCategory();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },


    /*关闭弹窗*/
    handleClose(param){
      this.dialogVisible=false;
      this.$emit('closeCategory',param);
    }
  }

}

</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/file/part/AddCategory3.vue